import { setMinutes, endOfDay, differenceInCalendarDays } from 'date-fns';

export default function getMonthAndYear(value) {
  if (!value) {
    return '-';
  }
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const date = new Date(value);
  const month = date.getMonth();
  const year = date.getFullYear();
  return `${months[month]}, ${year}`;
}

export function getTotalMonths(start, end) {
  const moveIn = start;
  const moveOut = end;
  if (moveOut) {
    const noOfMonthsBetweenYears = ((moveOut.getFullYear() - moveIn.getFullYear()) * 12);
    const noOfMonths = moveOut.getMonth() - moveIn.getMonth();
    return noOfMonthsBetweenYears + noOfMonths + 1;
  }
  return 1;
}

export function getTotalRemainingDays(start) {
  const moveIn = start;
  const date = moveIn.getDate();
  const currentYear = moveIn.getFullYear();
  const currentMonth = moveIn.getMonth();
  const totalDaysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  return (totalDaysInCurrentMonth - date) > 0 ? totalDaysInCurrentMonth - date : 0;
}

export function getOpenDaysFromCurrentDate(moveOut) {
  const date1 = new Date();
  const date2 = new Date(moveOut);
  const difference = date1.getTime() - date2.getTime();

  // To calculate the no. of days between two dates
  const result = Math.round(difference / (1000 * 3600 * 24));
  return result < 0 ? 0 : result;
}

export function getTotalDaysOfCurrentStayedInMonth(start) {
  const moveIn = start;
  const currentYear = moveIn.getFullYear();
  const currentMonth = moveIn.getMonth();
  return new Date(currentYear, currentMonth + 1, 0).getDate();
}

export function getNextBillingDate(start, end) {
  const moveIn = start;
  const moveOut = end;
  if (moveOut) {
    const moveInYear = moveIn.getFullYear();
    const moveInMonth = moveIn.getMonth();
    const moveOutYear = moveOut.getFullYear();
    const moveOutMonth = moveOut.getMonth();

    if (moveInYear === moveOutYear && moveInMonth === moveOutMonth) {
      return null;
    }
  }
  const lastDayOfMonth = this.getTotalDaysOfMoveInMonth();
  const companyPolicyNextBillingDate = new Date(
    moveIn.getFullYear(),
    moveIn.getMonth(),
    lastDayOfMonth - 7,
  );
  const lastDayDateOfMoveIn = new Date(moveIn.getFullYear(), moveIn.getMonth(), lastDayOfMonth);

  if (companyPolicyNextBillingDate < moveIn || companyPolicyNextBillingDate < new Date()) {
    if (lastDayDateOfMoveIn <= moveIn) {
      return new Date(moveIn.getFullYear(), moveIn.getMonth() + 1, 1);
    }
    return new Date(moveIn.getFullYear(), moveIn.getMonth(), lastDayOfMonth);
  }
  return companyPolicyNextBillingDate;
}

export function datelabel(start, end) {
  if (end) {
    return `(${new Date(start).toLocaleDateString()} - ${new Date(end).toLocaleDateString()})`;
  }
  return ' ';
}

export function getLocationStartDayBasedOnOffset(dueDate, offset = 0) {
  const adjustedFacilityOffset = offset < 0
    ? Math.abs(offset) : -Math.abs(offset);
  const startOfDueDateUTC = new Date(
    Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate()),
  );
  return setMinutes(startOfDueDateUTC, adjustedFacilityOffset);
}

export function setMoveinToUTC(moveIn) {
  return new Date(Date.UTC(
    moveIn.getFullYear(),
    moveIn.getMonth(),
    moveIn.getDate(),
    9,
  ));
}

export function setMoveoutToUTC(moveout) {
  return new Date(Date.UTC(
    moveout.getFullYear(),
    moveout.getMonth(),
    moveout.getDate(),
    17,
  ));
}

export function getLocationEndDayBasedOnOffset(date, offset = 0) {
  const adjustedFacilityOffset = offset < 0
    ? Math.abs(offset) : -Math.abs(offset);
  const startOfdateUTC = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );

  const endOfDateUTC = endOfDay(startOfdateUTC);
  return setMinutes(endOfDateUTC, adjustedFacilityOffset);
}

export function allowedCompleteLeaseDate(subjectDate, moveInDate, moveOutDate, moveOutType) {
  if (subjectDate < moveInDate) { return false; }

  if (moveOutType === 'delayed') {
    if (subjectDate < moveOutDate) { return false; }
    if (subjectDate.toDateString() === moveOutDate.toDateString()) { return false; }
    return true;
  } else if (moveOutType === 'earlier') {
    if (subjectDate > moveOutDate) { return false; }
    if (subjectDate.toDateString() === moveOutDate.toDateString()) { return false; }
    if (Math.abs(differenceInCalendarDays(subjectDate, moveOutDate)) > 3) { return false; }
    return true;
  }

  return false;
}

export function isDateBefore30Days(date, currentDate = new Date()) {
  const subjectDate = date instanceof Date ? date : new Date(date);
  const comparisonDate = currentDate instanceof Date ? currentDate : new Date(currentDate);

  if (Number.isNaN(subjectDate.getTime()) || Number.isNaN(comparisonDate.getTime())) {
    return false;
  }

  if (
    subjectDate.getFullYear() !== comparisonDate.getFullYear() ||
    subjectDate.getMonth() !== comparisonDate.getMonth()
  ) {
    return false;
  }

  const dateBefore30Days = new Date(comparisonDate);
  dateBefore30Days.setDate(comparisonDate.getDate() - 30);
  return subjectDate > dateBefore30Days;
}



// WEBPACK FOOTER //
// ./src/utils/timing.js